export enum LangEnum {
    NL = 'nl',
    FR = 'fr',
    EN = 'en'
}
